import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useFriendRequest } from '../../hooks/friend-request/useFriendRequest';
import ListFriendRequest from '../../components/list-friend-request/list-friend-request.component';
import ListFriendSuggestion from '../../components/friend-suggestion/friend-suggestion.component';
import { useSelector } from 'react-redux';
import { RootState } from '../../configuration';
import _get from 'lodash/get';
import { useFriendSuggestion } from '../../hooks/friend-suggestion/useFriendSuggestion';
import { routePaths } from '../../routes/routes-path';
import { ITab, Tab } from '../../components/tab/tab.component';
import { useFriend } from '../../hooks/use-friend/useFriend';
import { useParams, useSearchParams } from 'react-router-dom';
import { useUserProfile } from '../../hooks/profile/use-profile';
import _ from 'lodash';
import empty from '../../images/profile/empty.png';
import { Search } from 'lucide-react';

const tabFriend: ITab[] = [
  {
    label: 'Lời mời kết bạn',
    value: 'request',
  },
  {
    label: 'Danh sách bạn bè',
    value: routePaths.listFriend,
  },
  {
    label: 'Gợi ý kết bạn ',
    value: 'friendSuggest',
  },
];

export const FriendPage = () => {
  const { userId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentSubTab = searchParams.get('subTab') || tabFriend[1].value;
  const userProfile = useSelector(
    (state: RootState) => state.features.auth.profile
  );

  const { profile } = useUserProfile(
    _.toString(userId || userProfile?.username)
  );
  const isMe = profile?.userId === userProfile?.userId;

  const { getUserFriends, userFriends } = useFriend({ pageSize: 100 });

  const [tabValue, setTabValue] = useState<string>('');

  const { listFriendRequest, getListFriendRequest } = useFriendRequest();
  const { listFriendSuggestion, getListFriendSuggestion } =
    useFriendSuggestion();

  const handleAddFriendSuccess = async () => {
    await getListFriendRequest();
  };

  useEffect(() => {
    if (tabValue === tabFriend[0].value) {
      getListFriendRequest();
    }

    if (tabValue === tabFriend[1].value) {
      getListFriendSuggestion();
    }
  }, [tabValue]);

  useEffect(() => {
    if (profile) {
      getUserFriends(profile.userId);
    }
  }, [profile]);

  useEffect(() => {
    if (!isMe && currentSubTab === tabFriend[0].value) {
      setTabValue(tabFriend[1].value);
    } else {
      setTabValue(currentSubTab);
    }
  }, [isMe, currentSubTab]);

  const [searchQuery, setSearchQuery] = useState('');
  const filteredFriendRequests = listFriendRequest?.filter((friend) =>
    friend.fullName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const filteredFriends = userFriends?.filter((friend) =>
    friend.fullName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const filteredFriendSuggestions = listFriendSuggestion?.filter((friend) =>
    friend.requestFullName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Bạn bè - Cab</title>
        <meta name="description" content="Bạn bè" />
      </Helmet>
      <div>
        <div className="flex flex-col gap-8">
          <div className="flex-1">
            <div className="mb-[10px]">
              <Tab
                defaultValue={tabValue}
                items={
                  isMe
                    ? tabFriend
                    : [
                        {
                          label: 'Danh sách bạn bè',
                          value: routePaths.listFriend,
                        },
                      ]
                }
                onChange={(value) => {
                  setTabValue(value);
                  setSearchParams({ tab: 'friend', subTab: value });
                  setSearchQuery('');
                }}
              />
            </div>

            {/* <div className="mb-4 flex justify-between">
                <p className="text-md font-medium text-slate-800 dark:text-slate-50">Lời mời kết bạn</p>
                <Link
                  className="text-md font-medium text-primary-6 dark:text-slate-50"
                  to={`/${routePaths.listFriend}`}
                >
                  Danh sách bạn bè
                </Link>
              </div> */}

            {tabValue === tabFriend[0].value ? (
              <div className="w-full flex flex-col gap-[10px] p-3">
                <div className="flex justify-between items-center gap-[6px]">
                  <p className="text-[22px] w-full leading-[28px] font-semibold text-slate-800 dark:text-slate-50">
                    Lời mời kết bạn
                  </p>
                  <div className=" rounded-[32px] w-full  bg-secondery relative  dark:!bg-white/5">
                    <input
                      onChange={(e) => setSearchQuery(e.target.value)}
                      type="text"
                      placeholder="Tìm kiếm"
                      className="w-full !pl-4 !font-normal !bg-transparent h-[29px] !text-sm outline-none text-[#657384]"
                    />
                    <Search
                      size={20}
                      className="absolute top-1/2 right-3 transform -translate-y-1/2 "
                    />
                  </div>
                </div>
                <div>
                  {filteredFriendRequests ? (
                    <ListFriendRequest
                      data={filteredFriendRequests}
                      userId={_get(userProfile, 'userId', '')}
                      onSuccess={handleAddFriendSuccess}
                    />
                  ) : (
                    <div className="flex gap-4 w-full text-[#5D646F] flex-col justify-center items-center py-3">
                      <img src={empty} alt="empty" />
                      <p className="text-sm">Danh sách trống </p>
                    </div>
                  )}
                </div>
              </div>
            ) : null}
            {tabValue === tabFriend[1].value ? (
              <div className="w-full flex flex-col gap-[10px] p-3">
                <div className="flex justify-between items-center gap-[6px]">
                  <p className="text-[22px] w-full leading-[28px] font-semibold text-slate-800 dark:text-slate-50">
                    Bạn bè
                  </p>
                  <div className=" rounded-[32px] w-full  bg-secondery relative  dark:!bg-white/5">
                    <input
                      onChange={(e) => setSearchQuery(e.target.value)}
                      type="text"
                      placeholder="Tìm kiếm"
                      className="w-full !pl-4 !font-normal !bg-transparent h-[29px] !text-sm outline-none text-[#657384]"
                    />
                    <Search
                      size={20}
                      className="absolute top-1/2 right-3 transform -translate-y-1/2 "
                    />
                  </div>
                </div>
                <div>
                  {filteredFriends ? (
                    <ListFriendRequest
                      data={filteredFriends}
                      userId={_get(userProfile, 'userId', '')}
                      onSuccess={handleAddFriendSuccess}
                      hiddenAddFriend
                    />
                  ) : (
                    <div className="flex gap-4 w-full text-[#5D646F] flex-col justify-center items-center py-3">
                      <img src={empty} alt="empty" />
                      <p className="text-sm">Danh sách trống </p>
                    </div>
                  )}
                </div>
              </div>
            ) : null}
            {tabValue === tabFriend[2].value ? (
              <div className="w-full  p-3">
                <div className="flex justify-between items-center gap-[6px]">
                  <p className="text-[22px] w-full leading-[28px] font-semibold text-slate-800 dark:text-slate-50">
                    Gợi ý kết bạn
                  </p>
                  <div className=" rounded-[32px] w-full  bg-secondery relative  dark:!bg-white/5">
                    <input
                      onChange={(e) => setSearchQuery(e.target.value)}
                      type="text"
                      placeholder="Tìm kiếm"
                      className="w-full !pl-4 !font-normal !bg-transparent h-[29px] !text-sm outline-none text-[#657384]"
                    />
                    <Search
                      size={20}
                      className="absolute top-1/2 right-3 transform -translate-y-1/2 "
                    />
                  </div>
                </div>
                <div>
                  {filteredFriendSuggestions ? (
                    <div className="grid grid-cols-2 gap-[6px] mt-[10px]">
                      <ListFriendSuggestion
                        data={filteredFriendSuggestions}
                        userId={_get(userProfile, 'userId', '')}
                        onSuccess={() => {
                          getListFriendSuggestion();
                        }}
                      />
                    </div>
                  ) : (
                    <div className="flex gap-4 w-full text-[#5D646F] flex-col justify-center items-center py-3">
                      <img src={empty} alt="empty" />
                      <p className="text-sm">Danh sách trống </p>
                    </div>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};
